export default __webpack_public_path__ + "static/media/Warranties_round_icon.8e9eaa02.svg";